import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { parent } = gateway

// 获取学员是否存在迁移确认记录
export function getMigrateRecord (params) {
  return request({
    url: `${parent}/api/migrate/record/get`,
    method: 'GET',
    params
  })
}

// 保存学员迁移确认记录
export function saveMigrateRecord (params) {
  return request({
    url: `${parent}/api/migrate/record/save`,
    method: 'POST',
    params
  })
}
